export const relationGroupstables = {
    relationGroups: [{
        name: 'RELATION GROUP NAME',
        key: 'relation_group_name',
        link: 'relation-groups/',
        sort: true,
    },
    {
        name: 'MIN. RESPONDENTS',
        key: 'min_respondent',
        link: '',
        sort: true,
    },
    {
        name: 'DEFAULT ENABLED',
        key: 'default_enabled',
        link: '',
        sort: false,
    },
    {
        name: 'RELATIONS',
        key: 'relation_list',
        link: '',
        sort: false,
    }]
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/RelationGroups/relationGrouptableColumns.js